import { topicsData, rankingData } from '@/mocks/homeData';

export default function TopicsRankingSection() {
  return (
    <>
      <section id="topics" className="py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门话题</h2>
            <p className="mt-2 text-sm text-foreground-500">全网最热 · 实时追踪</p>
          </div>

          <div className="flex flex-wrap gap-3 justify-center">
            {topicsData.map((topic, idx) => (
              <div
                key={idx}
                className={`group flex items-center gap-3 px-5 py-3 rounded-full cursor-pointer transition-all duration-300 hover:-translate-y-0.5 ${
                  idx < 3 ? 'bg-primary-50 border border-primary-200' : 'bg-background-50 border border-background-200 hover:border-primary-200'
                }`}
              >
                <span className={`text-xs font-bold whitespace-nowrap ${
                  idx === 0 ? 'text-primary-600' :
                  idx === 1 ? 'text-accent-700' :
                  idx === 2 ? 'text-secondary-700' :
                  'text-foreground-700'
                }`}>#{topic.name}</span>
                <span className="flex items-center gap-1 text-[11px] text-foreground-400 whitespace-nowrap">
                  <i className={`text-[10px] ${
                    topic.trend === 'up' ? 'ri-arrow-up-line text-primary-500' :
                    topic.trend === 'down' ? 'ri-arrow-down-line text-secondary-500' :
                    'ri-subtract-line text-foreground-400'
                  }`}></i>
                  {topic.heat}
                </span>
                {topic.tag && (
                  <span className={`px-1.5 py-0.5 rounded text-[9px] font-bold whitespace-nowrap ${
                    topic.tag === '爆' ? 'bg-primary-600 text-background-50' :
                    topic.tag === '热' ? 'bg-accent-500 text-background-50' :
                    'bg-secondary-500 text-background-50'
                  }`}>{topic.tag}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="ranking" className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">黑料热榜</h2>
            <p className="mt-2 text-sm text-foreground-500">实时热度排名 · 全站最火内容</p>
          </div>

          <div className="bg-background-100 rounded-2xl overflow-hidden">
            {rankingData.map((item, idx) => (
              <div
                key={idx}
                className={`flex items-center gap-4 px-5 py-4 md:px-6 md:py-4 cursor-pointer hover:bg-background-50 transition-colors ${
                  idx < rankingData.length - 1 ? 'border-b border-background-200' : ''
                }`}
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                  idx === 0 ? 'bg-primary-600 text-background-50' :
                  idx === 1 ? 'bg-accent-500 text-background-50' :
                  idx === 2 ? 'bg-secondary-500 text-background-50' :
                  'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>
                <h3 className="flex-1 text-sm md:text-base font-medium text-foreground-800 leading-snug line-clamp-2">{item.title}</h3>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
                    <i className={`text-[10px] ${
                      item.change === 'up' ? 'ri-arrow-up-line text-primary-500' :
                      item.change === 'down' ? 'ri-arrow-down-line text-secondary-500' :
                      'ri-subtract-line text-foreground-400'
                    }`}></i>
                    {item.heat}
                  </span>
                  <i className="ri-arrow-right-s-line text-foreground-300"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}